import { slice as r } from "./_setup.js";
function t(t, u) {
  if (null == u || u < 1) return [];
  for (var n = [], e = 0, l = t.length; e < l;) n.push(r.call(t, e, e += u));
  return n;
}
export { t as default };